export default __webpack_public_path__ + "static/media/5.61f6c584.png";